import React, { memo, FC } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { profiles } from "./defaults";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { Image } from "cloudinary-react";
import useSwingProfileSelector from "./useSwingProfileSelector";

interface ProfilesProps {
  isWindow: boolean;
}

const SwingProfiles: FC<ProfilesProps> = ({ isWindow }) => {
  const { checkMark, variant, handleClick, stilesRailsProfile, exactConfig } =
    useSwingProfileSelector();

  return (
    <ReusableAccordian
      accordionName="stilesRailsProfile"
      heading={"Stiles and Rails Profile"}
      secondaryHeading="Select profile"
      colOrRow="col"
    >
      <ColLayout>
        <RowLayout style={{ paddingBottom: 20 }}>
          {profiles.map((state) => (
            <div key={state.id} onClick={() => handleClick(state.label)}>
              <Choices
                label={state.label}
                variant={variant(state.label)}
                checkMark={checkMark(state.label)}
                wide={true}
              />
            </div>
          ))}
        </RowLayout>

        {stilesRailsProfile && (
          <ProfileImg
            publicId={
              isWindow
                ? `Frame_Profile/Fixed_Panel/Full_Bound/OS_WINDOW_${stilesRailsProfile?.toUpperCase()}_v2`
                : `Frame_Profile/Swing/${
                    exactConfig.includes("Outswing") ? "OS" : "IS"
                  }_${stilesRailsProfile?.toUpperCase()}`
            }
          />
        )}
      </ColLayout>
    </ReusableAccordian>
  );
};

interface ProfileImgProps {
  publicId: string;
}

const ProfileImg: FC<ProfileImgProps> = ({ publicId }) => {
  return (
    <div style={{ height: 239 }}>
      <Image cloudName="ag-millworks" secure="true" publicId={publicId} />
    </div>
  );
};

export default memo(SwingProfiles);
